import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import authService from 'store/auth/service';
import { UnsecuredDriverLoginPage } from 'routes/paths';
import { LoaderArrow } from 'components/Loaders/LoaderArrow';
import { localStorageWrapper } from 'functions/localStorage';

export const DriverLogoutPage = () => {
  const navigate = useNavigate();
  const [logout] = authService.useLogoutMutation();

  useEffect(() => {
    (async () => {
      await logout();
      window.analytics.reset();

      localStorageWrapper.clear();

      navigate(UnsecuredDriverLoginPage);
    })();
  }, []);

  return <LoaderArrow>Logout...</LoaderArrow>;
};
